import { render, staticRenderFns } from "./ErrorArea.vue?vue&type=template&id=6ce588e0&"
import script from "./ErrorArea.vue?vue&type=script&lang=js&"
export * from "./ErrorArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports